import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	${({ showArrows }) => showArrows && `container-type: inline-size;`}

	> button {
		padding: 1rem 2rem !important;
		border: 1px solid var(--border-color) !important;
		height: 4.5rem;
		min-height: 4.5rem;

		&.minus-button {
			border-right: unset !important;
			border-radius: var(--small-border-radius) 0 0 var(--small-border-radius);

			body[dir='rtl'] & {
				border: 1px solid var(--border-color) !important;
				border-left: unset !important;
				border-radius: 0 var(--small-border-radius) var(--small-border-radius) 0;
			}
		}

		&.plus-button {
			border-left: unset !important;
			border-radius: 0 var(--small-border-radius) var(--small-border-radius) 0;

			body[dir='rtl'] & {
				border: 1px solid var(--border-color) !important;
				border-right: unset !important;
				border-radius: var(--small-border-radius) 0 0 var(--small-border-radius);
			}
		}

		body[dir='rtl'] & {
			height: 5.5rem;
			min-height: 5.5rem;
		}
	}

	.string-input-error-message-container {
		${({ showArrows }) => showArrows && `margin: 0 -5rem;`}
	}

	@container (max-width: 16rem) {
		> button {
			padding: 1rem !important;
		}

		.string-input-error-message-container {
			${({ showArrows }) => showArrows && `margin: 0 -3rem;`}
		}
	}

	@container (max-width: 12rem) {
		> button {
			display: none;
		}

		input {
			border-radius: var(--small-border-radius) !important;
		}

		.string-input-error-message-container {
			${({ showArrows }) => showArrows && `margin: 0;`}
		}
	}
`;

export const InputContainer = styled.div`
	width: 100%;
	position: relative;

	> input {
		${({ showArrows }) => showArrows && `text-align: center;`}
		${({ unitPosition, inputContainerPadding }) => `padding-${unitPosition}: ${inputContainerPadding}rem;`}

		body[dir='rtl'] & {
			${({ unitPosition }) => `padding-${unitPosition}: var(--inputPadding);`}
			${({ unitPosition, inputContainerPadding }) =>
				`padding-${unitPosition === 'right' ? 'left' : 'right'}: ${inputContainerPadding}rem;`}
		}

		${({ showArrows }) => showArrows && `border-radius: 0;`}

		-moz-appearance: textfield; /* Firefox fix */
		::-webkit-outer-spin-button,
		::-webkit-inner-spin-button {
			/* display: none; <- Crashes Chrome on hover */
			-webkit-appearance: none;
			margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
		}
	}

	> .max-placeholder {
		position: absolute;
		top: 1.25rem;
		right: 0.5rem;
		${({ viewMode }) => `${viewMode ? 'top: 0;' : ''}`}

		body[dir='rtl'] & {
			right: auto;
			left: 0.5rem;
		}
	}
`;

export const UnitContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 1.25rem;
	${({ viewMode }) => `${viewMode ? 'top: 0;' : ''}`}
	${({ unitPosition }) => `${unitPosition}: 0`};
	${({ unitPosition }) => `margin-${unitPosition}: 1.2rem;`}
	color: var(--content-3);
	font-size: var(--paragraph3-font-size);
	font-weight: 700;

	body[dir='rtl'] & {
		${({ unitPosition }) => `${unitPosition}: unset;`}
		${({ unitPosition }) => `${unitPosition === 'right' ? 'left' : 'right'}: 0;`}
		${({ unitPosition }) => `margin-${unitPosition}: 1.2rem;`}
		${({ unitPosition }) => `margin-${unitPosition === 'right' ? 'left' : 'right'}: 1.2rem;`}
	}
`;
